import { render, staticRenderFns } from "./myrecord.vue?vue&type=template&id=5ee09398&scoped=true&"
import script from "./myrecord.vue?vue&type=script&lang=js&"
export * from "./myrecord.vue?vue&type=script&lang=js&"
import style0 from "./myrecord.vue?vue&type=style&index=0&id=5ee09398&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee09398",
  null
  
)

export default component.exports